var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base"},[_c('v-facebook-login',{attrs:{"app-id":"237731426239115","login-options":this.fb_obj},on:{"login":_vm.onLogin,"sdk-init":_vm.sdkLoaded,"logout":_vm.onLogout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }